import React from 'react';
import { Menu, X } from 'lucide-react';
import Logo from './Logo';
import { NavigationProps, SectionId } from '../types';

const Navigation: React.FC<NavigationProps> = ({ activeSection, isMenuOpen, setIsMenuOpen, isScrolled, scrollTo }) => {
  const sections: SectionId[] = ['home', 'about', 'skills', 'projects', 'contact'];
  return (
    <nav
      className={`fixed top-0 w-full z-50 transition-all duration-300 ${
        isScrolled || isMenuOpen
          ? "bg-ink-900/90 backdrop-blur-md border-b border-slate-700/50"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <button
            onClick={() => scrollTo('home')}
            aria-label="Go to top"
            className="transition-transform duration-300 hover:scale-[1.03]"
          >
            <Logo />
          </button>

          {/* Desktop Menu */}
          <div className="hidden md:flex space-x-8">
            {sections.map((item) => (
                <button
                  key={item}
                  onClick={() => scrollTo(item)}
                  className={`capitalize transition-all duration-300 hover:text-emerald-400 ${
                    activeSection === item
                      ? "text-emerald-400 border-b-2 border-emerald-400"
                      : ""
                  }`}
                >
                  {item}
                </button>
              )
            )}
          </div>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? (
              <X className="w-6 h-6" />
            ) : (
              <Menu className="w-6 h-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-slate-700/50 bg-ink-900/90 backdrop-blur-md">
            {sections.map((item) => (
                <button
                  key={item}
                  onClick={() => scrollTo(item)}
                  className="block w-full text-left py-2 capitalize hover:text-emerald-400 transition-colors"
                >
                  {item}
                </button>
              )
            )}
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navigation;